import { utilities } from "../../styles";

function CurrentLineupButtons(props: {
  handleNewsClicked: () => void;
  handleLeaderboardClicked: () => void;
  handleHowToPlay: () => void;
  handleSearchOpened: () => void;
}) {
  const {
    handleNewsClicked,
    handleLeaderboardClicked,
    handleHowToPlay,
    handleSearchOpened,
  } = props;
  return (
    <div className={`${utilities["flex-center"]} ${utilities["flex-gap"]}`}>
      {/* <div className={`${utilities["flex-row"]} ${utilities["flex-gap"]}`}>
        <NewsButton handleNewsClicked={handleNewsClicked} />
        <button
          className={globals["main-btn"]}
          onClick={handleLeaderboardClicked}
        >
          Leaderboard
        </button>
        <button className={globals["main-btn"]} onClick={handleHowToPlay}>
          Rules
        </button>
      </div> */}
    </div>
  );
}
export default CurrentLineupButtons;
